import apiClient from './client';

// ─── Types ──────────────────────────────────────────────────────────────────

export type JobState = 'created' | 'running' | 'completed' | 'failed' | 'failed_permanent';

export interface JobStatus {
  id: string;
  state: JobState;
  progress: number; // 0–100
  result: Record<string, unknown> | null;
  error: string | null;
  createdAt: string;
  completedAt: string | null;
}

export interface ExportJob {
  jobId: string;
  created_at: string;
  state: JobState;
  progress: number;
  downloadUrl: string | null;
  expiresAt: string | null;
}

export interface AlertAttempt {
  attempt_num: number;
  status: string;
  timestamp: string;
  error: string | null;
}

export interface AlertDelivery {
  jobId: string;
  alertId: string | null;
  status: JobState;
  attempts: AlertAttempt[];
}

export interface RetryJobResponse {
  jobId: string;
  newStatus: string;
  nextRetryAt: string;
}

// ─── API Functions ───────────────────────────────────────────────────────────

export async function getJobStatus(jobId: string): Promise<JobStatus> {
  const res = await apiClient.get<JobStatus>(`/analytics/jobs/${jobId}`);
  return res.data;
}

export async function retryJob(jobId: string): Promise<RetryJobResponse> {
  const res = await apiClient.post<RetryJobResponse>(`/analytics/jobs/${jobId}/retry`);
  return res.data;
}

export async function getUserExports(userId: string): Promise<ExportJob[]> {
  const res = await apiClient.get<ExportJob[]>(`/analytics/users/${userId}/exports`);
  return res.data;
}

export async function getAlertDeliveries(userId: string): Promise<AlertDelivery[]> {
  const res = await apiClient.get<AlertDelivery[]>(`/analytics/users/${userId}/alerts/deliveries`);
  return res.data;
}
